import titleCase from 'common/utils/titleCase';

// Mirrors e-scribe-ui's Formulary display formatting (casingFormat /
// capitalizeStrength in common/utils.ts) so catalog drug names and strengths
// read the same in both apps regardless of how they were entered.
export const formatDrugName = (drugName) => titleCase(drugName) || drugName;

// Same title-case treatment, but leaves the "N/A" sentinel used throughout the
// catalog UI for an unset strength untouched -- title-casing it would
// otherwise turn it into "N/a".
export const formatStrength = (strength) =>
  strength && strength !== 'N/A' ? titleCase(strength) : strength || 'N/A';

export const formatForm = (formAlias, dosageForm) => {
  if (formAlias && dosageForm) return `${formAlias} (${dosageForm})`;
  return formAlias || dosageForm || '-';
};

export const formatPackSize = (packSizeValue, packSizeUnit) =>
  packSizeValue ? `${packSizeValue}${packSizeUnit || ''}` : '-';
